// import React, { useEffect, useState } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import axios from "axios";
// import { RiArrowDownSLine, RiCloseLine } from "react-icons/ri";

// const DownloadModal = ({ isOpen, onClose }) => {
//   const [services, setServices] = useState([]);
//   const [downloads, setDownloads] = useState([]);
//   const [expandedService, setExpandedService] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (isOpen) {
//       fetchData();
//     }
//   }, [isOpen]);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const [serviceRes, downloadRes] = await Promise.all([
//         axios.get(`${process.env.REACT_APP_API_URL}/services/get-all-services-data`),
//         axios.get(`${process.env.REACT_APP_API_URL}/download/all`)
//       ]);
//       setServices(serviceRes.data || []);
//       setDownloads(downloadRes.data || []);
//     } catch (err) {
//       console.error("Error loading data:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Use URLs directly without adding any base URL
//   const getDownloadLinks = (subserviceId) => {
//     const entry = downloads.find(d => d.subservice._id === subserviceId);
//     if (!entry || !entry.pdfFiles || entry.pdfFiles.length === 0) return [];
//     return entry.pdfFiles; // Directly return Cloudinary URLs
//   };

//   const toggleService = (id) => {
//     setExpandedService(expandedService === id ? null : id);
//   };

//   if (!isOpen) return null;

//   return (
//     <AnimatePresence>
//       <motion.div
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//         className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]"
//         onClick={onClose}
//       >
//         <motion.div
//           initial={{ scale: 0.9, opacity: 0 }}
//           animate={{ scale: 1, opacity: 1 }}
//           exit={{ scale: 0.9, opacity: 0 }}
//           transition={{ duration: 0.3 }}
//           className="bg-white rounded-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto shadow-xl relative p-6"
//           onClick={(e) => e.stopPropagation()}
//         >
//           {/* Close Button */}
//           <button
//             onClick={onClose}
//             className="absolute top-3 right-3 text-gray-600 hover:text-red-500 transition"
//           >
//             <RiCloseLine size={24} />
//           </button>

//           <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
//             📂 Download Service PDFs
//           </h2>

//           {loading ? (
//             <div className="text-center text-gray-500 py-10">Loading...</div>
//           ) : (
//             <div className="space-y-4">
//               {services.map((service) => (
//                 <div
//                   key={service._id}
//                   className="border border-gray-200 rounded-lg shadow-sm"
//                 >
//                   {/* Service Header */}
//                   <div
//                     onClick={() => toggleService(service._id)}
//                     className="flex justify-between items-center p-4 cursor-pointer hover:bg-gray-50 transition"
//                   >
//                     <span className="font-semibold text-gray-800">
//                       {service.serviceName}
//                     </span>
//                     <RiArrowDownSLine
//                       className={`transition-transform ${
//                         expandedService === service._id ? "rotate-180" : ""
//                       }`}
//                       size={22}
//                     />
//                   </div>

//                   {/* Subservices & PDFs */}
//                   <AnimatePresence>
//                     {expandedService === service._id && (
//                       <motion.div
//                         initial={{ height: 0, opacity: 0 }}
//                         animate={{ height: "auto", opacity: 1 }}
//                         exit={{ height: 0, opacity: 0 }}
//                         className="px-6 pb-4"
//                       >
//                         {service.subservices?.length > 0 ? (
//                           service.subservices.map((sub) => {
//                             const pdfLinks = getDownloadLinks(sub._id);
//                             return (
//                               <div
//                                 key={sub._id}
//                                 className="py-2 border-b last:border-b-0"
//                               >
//                                 <div className="flex justify-between items-center">
//                                   <span className="text-gray-700">
//                                     {sub.subserviceName}
//                                   </span>
//                                 </div>

//                                 {/* PDF Download Buttons */}
//                                 <div className="mt-1 space-x-2">
//                                   {pdfLinks.length > 0 ? (
//                                     pdfLinks.map((link, idx) => (
//                                       <a
//                                         key={idx}
//                                         href={link}
//                                         target="_blank"
//                                         rel="noopener noreferrer"
//                                         className="bg-yellow-400 text-black px-3 py-1 rounded-md text-sm font-medium hover:bg-yellow-500 transition inline-block"
//                                         download
//                                       >
//                                         PDF {idx + 1}
//                                       </a>
//                                     ))
//                                   ) : (
//                                     <span className="text-gray-400 text-sm">
//                                       No file
//                                     </span>
//                                   )}
//                                 </div>
//                               </div>
//                             );
//                           })
//                         ) : (
//                           <div className="text-gray-500 text-sm py-3">
//                             No subservices available.
//                           </div>
//                         )}
//                       </motion.div>
//                     )}
//                   </AnimatePresence>
//                 </div>
//               ))}
//             </div>
//           )}
//         </motion.div>
//       </motion.div>
//     </AnimatePresence>
//   );
// };

// export default DownloadModal;

import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import axios from "axios";
import { RiArrowDownSLine, RiCloseLine } from "react-icons/ri";

const DownloadModal = ({ isOpen, onClose, serviceId }) => {
  const [service, setService] = useState(null);
  const [downloads, setDownloads] = useState([]);
  const [expanded, setExpanded] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isOpen && serviceId) {
      fetchData();
    }
  }, [isOpen, serviceId]);

  const fetchData = async () => {
    try {
      setLoading(true);

    
      const [serviceRes, downloadRes, subserviceRes] = await Promise.all([
        axios.get(`${process.env.REACT_APP_API_URL}/services/get-all-services-data`),
        axios.get(`${process.env.REACT_APP_API_URL}/download/all`),
        axios.get(`${process.env.REACT_APP_API_URL}/subservices/get-all-subservices`) 
      ]);

      const allServices = serviceRes.data || [];
      const allDownloads = downloadRes.data || [];
      const allSubservices = subserviceRes.data.data || [];

    
      const selected = allServices.find(s => s._id === serviceId);

   
      const merged = {
        ...selected,
        subservices: allSubservices.filter(sub => sub.service._id === serviceId)
      };

      setService(merged);
      setDownloads(allDownloads);
    } catch (err) {
      console.error("Error loading data:", err);
    } finally {
      setLoading(false);
    }
  };

  const getDownloadLinks = (subserviceId) => {
    const entry = downloads.find(d => d.subservice?._id === subserviceId);
    return entry?.pdfFiles || [];
  };

  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]"
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="bg-white rounded-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto shadow-xl relative p-6"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <button
            onClick={onClose}
            className="absolute top-3 right-3 text-gray-600 hover:text-red-500 transition"
          >
            <RiCloseLine size={24} />
          </button>

          <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
            📂 Download PDFs
          </h2>

          {loading ? (
            <div className="text-center text-gray-500 py-10">
              Loading data...
            </div>
          ) : service ? (
            <div className="border border-gray-200 rounded-lg shadow-sm">
              {/* Service Header */}
              <div
                onClick={() => setExpanded(!expanded)}
                className="flex justify-between items-center p-4 cursor-pointer hover:bg-gray-50 transition"
              >
                <span className="font-semibold text-gray-800">
                  {service.serviceName || "Service"}
                </span>
                <RiArrowDownSLine
                  className={`transition-transform ${
                    expanded ? "rotate-180" : ""
                  }`}
                  size={22}
                />
              </div>

              {/* Subservices */}
              <AnimatePresence>
                {expanded && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="px-6 pb-4"
                  >
                    {service.subservices?.length > 0 ? (
                      service.subservices.map((sub) => {
                        const pdfLinks = getDownloadLinks(sub._id);
                        return (
                          <div
                            key={sub._id}
                            className="py-2 border-b last:border-b-0"
                          >
                            <span className="text-gray-700">
                              {sub.subserviceName}
                            </span>
                            <div className="mt-1 space-x-2">
                              {pdfLinks.length > 0 ? (
                                pdfLinks.map((link, idx) => (
                                  <a
                                    key={idx}
                                    href={link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-yellow-400 text-black px-3 py-1 rounded-md text-sm font-medium hover:bg-yellow-500 transition inline-block"
                                    download
                                  >
                                    PDF {idx + 1}
                                  </a>
                                ))
                              ) : (
                                <span className="text-gray-400 text-sm">
                                  No file
                                </span>
                              )}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="text-gray-500 text-sm py-3">
                        No subservices available.
                      </div>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ) : (
            <div className="text-center text-gray-500 py-10">
              Service not found.
            </div>
          )}
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default DownloadModal;
